import ApiService from "../../services/ApiService";
import { HandoverV2DetailParams } from "@/data/payload/api/HandoverV2ApiRequest";
import { HandoverV2Mapper } from "@/data/persistences/mappers/HandoverV2Mapper";
import { HandoverV2Endpoints } from "../../endpoints/hydra/HandoverV2Endpoints";

export class HandoverV2ApiRepository {
  private service: ApiService;
  private mapper: HandoverV2Mapper;
  private endpoints: HandoverV2Endpoints;

  constructor(
    service: ApiService,
    mapper: HandoverV2Mapper,
    endpoints: HandoverV2Endpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getDetailHandover(params: HandoverV2DetailParams) {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getDetailHandover(params),
      {}
    );
    return this.mapper.convertGetDetailHandoverFromApi(resp);
  }
}
